var _defs, _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp2Sticker3DIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e,.f,.g{fill:none;}.b{fill:#3c3c46;opacity:0.15;}.c,.d,.e,.f,.g{fill-rule:evenodd;}.c{fill:url(#a);}.d,.e{stroke:#3c3c46;}.d,.e,.f,.g{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.d{fill:url(#b);}.f{stroke:#89d9fb;}.g{stroke:#fff;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 52.63,
    cy: 51.03,
    r: 63.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#78d2f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#249fda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0072bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78d2f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 64.03,
    y1: 61.83,
    x2: 78.48,
    y2: 79.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbbec2"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-sticker-3D-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 74.5,
    cy: 74.5,
    r: 41
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M65.5,106.5a41,41,0,1,0-41-41A41.08,41.08,0,0,0,65.5,106.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M75.2,57l-2.8,2.8a7.78,7.78,0,1,0,0,11l8.77,8.77a20.19,20.19,0,1,1,0-28.55Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M65.5,106.5a41,41,0,1,0-41-41A41.08,41.08,0,0,0,65.5,106.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M74.3,98.34a34,34,0,0,1-8.8,1.16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M99.5,65.5a34,34,0,0,1-17,29.44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M31.5,65.5a34,34,0,0,1,34-34"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp2Sticker3DIcon);
export default __webpack_public_path__ + "static/media/CP2-sticker-3D-icon.4ad20ce5f12d505637df285625ffa6d4.svg";
export { ForwardRef as ReactComponent };